





































































import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import Profile from "@/components/Profile.vue";
import { Location } from 'vue-router/types/router';
import { SearchAgentsMixin } from "@/mixins/SearchAgentMixin";

import { container } from "@/services/registerServiceProvider";
import { Agent } from "@/models/Agent";
import { searchProperties } from "@/models/SearchProperty";
import { IUserRoleService } from "@/services/IUserRoleService";

@Component({
  components: { Profile }
})
export default class SearchSegmentation extends mixins(SearchAgentsMixin) {
  @Prop() public readonly customSelectEvent?: boolean;
  @Prop() public readonly blackList?: Agent[];
  private readonly userRoleService: IUserRoleService = container.resolve("IUserRoleService");

  get agentNotAvailableArray(): Agent[] {
    return this.blackList
      ? this.blackList.filter(i => this.agentArray.map(i => i.id).includes(i.id))
      : [];
  }

  get agentAvailableArray(): Agent[] {
    return this.agentArray.filter(i => !this.blackList || !this.blackList.map(i => i.id).includes(i.id));
  }

  getLink(agent: Agent): Location {
    let route: Location = { name: 'segmentation-editor', params: { agentId: agent.id } };

    if (this.userRoleService.isHasChangeParentRole) {
      route = { name: 'agent-dashboard', params: { id: agent.id || '' } }
    }

    return route;
  }

  created() {
    if (this.userRoleService.isAdmin) {
      this.searchProperties = searchProperties;
    } else {
      this.searchProperties = searchProperties
        .filter(i => i.text === 'Имя' || i.text === 'Логин');
    }


    this.searchProperty = this.searchProperties[0];
  }
}
